import { ApiHosts, handleResponseOld, makeGet, makePost } from '@/redux/api/helpers';
import { FetchBidderDataResponse } from '@/redux/modules/account/user/user.types';

/**
 * @category Item API
 * @see getBidderData
 */
type FetchBidderDataParams = {
    authToken: string;
    deployment: string;
};

/**
 * GET request to item-api to load Bidder data
 * @function fetchBidderData
 * @category Item API
 * @param {FetchBidderDataParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/auth/spauser
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/react-site/routes/get-spa-user.ts
 */
export const getBidderData = ({ authToken, deployment }: FetchBidderDataParams) =>
    new Promise<FetchBidderDataResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'auth/spauser',
            authToken,
            deployment,
            path: ApiHosts.ItemApi,
        });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

type PostVipConfirmationSeenParams = {
    authToken: string;
    bidderId: number;
    deployment: string;
};

/**
 * Marks the VIP welcome modal as seen for this bidder. Idempotent: a repeat call keeps the original timestamp.
 * @see https://flynn-DEPLOYMENT.liveauctioneers.com/user/${bidderId}/vip-confirmation-seen
 */
export const postVipConfirmationSeen = ({ authToken, bidderId, deployment }: PostVipConfirmationSeenParams) =>
    new Promise((resolve, reject) => {
        const request = makePost({
            apiPath: `${bidderId}/vip-confirmation-seen`,
            authToken,
            deployment,
            path: ApiHosts.FlynnUser,
        });
        request.send();
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
